export default __webpack_public_path__ + "static/media/trackinfo_tunnel.f51edab0.png";